var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYticonelement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.13,207.71l73,64L287,257.08a469.38,469.38,0,0,1-81.1,29.08l11.45,6.5a217.27,217.27,0,0,1,5.35-86c3.07-11.59-14.87-16.53-17.94-4.95a240.75,240.75,0,0,0-5.35,95.89c.71,5,7.08,7.63,11.44,6.5a497.13,497.13,0,0,0,85.54-31c5.25-2.45,6.12-10.89,1.88-14.61l-73-64c-9-7.87-22.18,5.24-13.16,13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,157.78l217.49-12.91c17.67-1.05,35.39-2.57,53.09-3.06,13.54-.38,27,1.54,32.78,15.38,5.73,13.63,5.34,30.36,5.44,44.85a294,294,0,0,1-4,51.06C416.17,282.16,408.48,316,385,335.94c-23.85,20.25-59.43,22-89.19,22.05-36.38,0-72.6-4.9-108.7-8.94l-53.71-6L105.74,340c-8.54-1-18.8-.54-27-3.15-6.39-2-3.89-13.25-3.84-18.8.08-8.1.22-16.21.5-24.3a396.9,396.9,0,0,1,4.21-48.46c5-31.06,15.12-61.61,36.24-85.51,7.91-8.94-5.2-22.15-13.15-13.16-43.31,49-46.39,117.65-46.45,179.85,0,6.69.33,13.76,4.15,19.51,4.78,7.19,12.76,8.91,20.78,9.88,20.43,2.48,40.93,4.58,61.39,6.87,40.27,4.5,80.59,10,121,12.74,35.56,2.41,74.81,3.33,108.39-10.53,32.33-13.34,50.07-41.5,59.59-74a310.38,310.38,0,0,0,11.19-110.59c-1.17-14.92-3.42-30.63-13.41-42.46-10.51-12.44-27.07-15-42.5-14.6-44.23,1.23-88.56,5.17-132.73,7.79L116.3,139.17c-11.9.71-12,19.32,0,18.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYticonelement);
export default __webpack_public_path__ + "static/media/yt icon element.5c20239e5b5635e03ecfa1dc5d924bf6.svg";
export { ForwardRef as ReactComponent };